import React, { useState } from 'react';
import CourseService from '../services/CourseService';

export default function CertificateLookupPublic() {
  const [referenceId, setReferenceId] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleSearch = async () => {
    try {
      setError('');
      const data = await CourseService.consultCertificate(referenceId.trim());
      setResult(data || null);
    } catch (err) {
      setResult(null);
      setError(err?.response?.data?.error || 'Certificado não encontrado.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: 24 }}>
      <div style={{ maxWidth: 720, margin: '0 auto', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 20 }}>
        <h1 style={{ marginBottom: 8 }}>Consulta pública de certificados</h1>
        <p style={{ marginBottom: 16, color: '#475569' }}>Informe o ID de referência para validar um certificado.</p>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            style={{ flex: 1, padding: 10, borderRadius: 8, border: '1px solid #cbd5e1' }}
            placeholder="Ex.: LMB-2026-000001"
            value={referenceId}
            onChange={(event) => setReferenceId(event.target.value)}
          />
          <button type="button" onClick={handleSearch} style={{ padding: '10px 14px', borderRadius: 8, border: 'none', background: '#2563eb', color: '#fff', fontWeight: 600 }}>
            Consultar
          </button>
        </div>

        {error ? <p style={{ marginTop: 12, color: '#dc2626' }}>{error}</p> : null}

        {result ? (
          <div style={{ marginTop: 16, border: '1px solid #e2e8f0', borderRadius: 10, padding: 12 }}>
            <p><strong>Referência:</strong> {result.referenceId}</p>
            <p><strong>Aluno:</strong> {result.userName}</p>
            <p><strong>Curso:</strong> {result.courseTitle}</p>
            <p><strong>Carga horária:</strong> {result.estimatedHours}h</p>
            <p><strong>Emitido em:</strong> {new Date(result.issuedAt).toLocaleString('pt-BR')}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
}
